export default "/images/vendor/@coreui/icons/svg/flag/cif-na.svg?032fd36a49dc736a0d24d4d7ede63938";